// based on Cola solver
// view-source:https://ialab.it.monash.edu/webcola/examples/smallnonoverlappinggraph.html

// Influence by https://observablehq.com/@d3/force-directed-graph
import { drag } from 'd3-drag';
import { event, select } from 'd3-selection';
import { flatten, isUndefined, keyBy, get } from 'lodash';
import { buildCrosslink, getBuildLinePath, makeTree } from '../../utils/tree';

import { dispatch } from 'd3-dispatch';
import { timer } from 'd3-timer'

import { d3adaptor } from 'webcola';

const d3 = {
  dispatch,
  timer,
  drag,
  event
};

const getCrossLinks = (nodeList) => {
  const nodeMap = keyBy(nodeList, "data.name");
  const makeCrossLinks = d => {
    const neighbors = d.data.crosslinks;
    const start = d;
    return neighbors.split("|").map(neighbor => {
      const end = nodeMap[neighbor];
      return [start, end];
    });
  };

  const nodesWithCrossLink = nodeList.filter(d => d.data.crosslinks);
  return flatten(nodesWithCrossLink.map(makeCrossLinks));
}

// Temporary hack to deal with the fact that x and y are reversed and it confuses the x events
// Same as in tree, except the x/y accessors are flipped
export const buildLinePathStraightForce = d => `
        M${d.target.x},${d.target.y}
        L${d.source.x},${d.source.y}
      `;
export const buildCrosslinkForce = pair => {
  const [start, end] = pair;
  if (pair.some(item => item === undefined)) {
    return ''
  }
  return `
        M${start.x},${start.y}
        L${end.x},${end.y}
      `;
};

export const render = (anchor, hierarchyData, width) => {
  const root = makeTree(hierarchyData, width);
  const svg = select(anchor);


  svg.select('.treeViz').remove(); // prevent overdrawing
  const nodeList = root.descendants().reverse();
  const g = svg
    .append("g")
    .classed('treeViz', true)
    .attr('transform', `translate(${0},${-window.innerHeight / 2})`);

  const yOffset = root.dy / 3;
  const buildLinePath = getBuildLinePath(yOffset);
  const crossLinks = getCrossLinks(nodeList);

  const link = g
    .append("g")
    .classed('linkGroup', true)
    .selectAll("path")
    .data(root.links());
  const crossLink = g
    .append("g")
    .classed('crossLinkGroup', true)
    .selectAll("path")
    .data(crossLinks);

  const nodeGroup = g
    .append("g")
    .classed("nodeGroup", true)
    .selectAll("g")
    .data(nodeList);

  // Bind data to the DOM
  const linkPaths = link.enter()
    .append("path")
    .attr("d", buildLinePath);

  const crossLinkPaths = crossLink.enter()
    .append("path")
    .attr("d", buildCrosslink);

  const node = nodeGroup.enter()
    .append("g")
    .classed("clickableNode", d => d.data.url !== undefined)
    .attr("transform", d => `translate(${d.y},${d.x})`)
    .on("click", d => {
      if (d.data.url) {
        window.open(`${d.data.url}`, "_blank");
      }
    });

  const texts = node
    .append("text")
    .attr("dy", "0.31em")
    .text(d => get(d, `data.name`, '').substr(0, 10))
    .attr("text-anchor", 'middle');

  // start animating - might work in react too, just the ticked function is different.
  // Would start the simulation right away at the beginning and use react spring
  // it's really just dragging that breaks down
  const linksList = root.links();
  const crossLinksList = crossLinks.map(([source, target], i) => ({
    source,
    target,
    index: i + linksList.length
  }));
  const allLinks = linksList.concat(crossLinksList).filter(
    link => !isUndefined(link.source) && !isUndefined(link.target)
  );

  const colaLib = d3adaptor(d3)
    .avoidOverlaps(true)
    .linkDistance(120)
    .size([width, window.innerHeight]);

  const simulation = colaLib
    .nodes(nodeList)
    .links(allLinks);

  const ticked = () => {
    node.attr("transform", d => `translate(${d.x},${d.y})`);
    linkPaths
      .attr("d", buildLinePathStraightForce);
    crossLinkPaths
      .attr("d", buildCrosslinkForce);
  };

  // This doesn't work because the internal library is trying to call
  // nodeGroup.call(simulation.drag);
  // node.call(simulation.drag);

  simulation
    .on("tick", ticked)
    .start();

}

export default {
  render
}
